import { API_URLS } from '@helpers/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import qs from 'query-string';
const INITIAL_STATE = {
    apiData: undefined,
    apiStatus: 'initial',
    filterExpanded: true,
    selectedLocationId: '',
};
export const fetchLocations = createAsyncThunk('locations/fetch', async (params) => {
    const response = await fetch(`${API_URLS.getLocations}?${qs.stringify(params)}`);
    return (await response.json());
});
export const locations = createSlice({
    name: 'locations',
    initialState: INITIAL_STATE,
    reducers: {
        deselectLocation: (state) => {
            state.selectedLocationId = '';
        },
        selectLocation: (state, action) => {
            state.selectedLocationId = action.payload;
        },
        toggleFilter: (state, action) => {
            if (action.payload === undefined) {
                state.filterExpanded = !state.filterExpanded;
            }
            else {
                state.filterExpanded = action.payload;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLocations.fulfilled, (state, action) => {
            state.apiData = action.payload;
            state.apiStatus = 'complete';
            state.selectedLocationId = '';
        });
        builder.addCase(fetchLocations.pending, (state) => {
            state.apiStatus = 'loading';
            state.selectedLocationId = '';
        });
        builder.addCase(fetchLocations.rejected, (state) => {
            state.apiData = undefined;
            state.apiStatus = 'complete';
            state.selectedLocationId = '';
        });
    },
});
const INITIAL_RANGES_STATE = {
    apiData: undefined,
    apiStatus: 'initial',
};
export const fetchLocationRanges = createAsyncThunk('locations/fetchRanges', async (params) => {
    const response = await fetch(`${API_URLS.getLocationRanges}?${qs.stringify(params)}`);
    return (await response.json());
});
export const locationRanges = createSlice({
    name: 'locationRanges',
    initialState: INITIAL_RANGES_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLocationRanges.fulfilled, (state, action) => {
            state.apiData = action.payload;
            state.apiStatus = 'complete';
        });
        builder.addCase(fetchLocationRanges.pending, (state) => {
            state.apiStatus = 'loading';
        });
        builder.addCase(fetchLocationRanges.rejected, (state) => {
            state.apiData = undefined;
            state.apiStatus = 'complete';
        });
    },
});
